import "core-js/stable";
import "regenerator-runtime/runtime";
import setup from "./setup";

// Expose to re-setup via Catalyst.js's wireUpFormControls
(window as any).setupReactComponents = setup;
